export * from './translit.constants';

export function transliterate(text: string, dictionary: { ua: string, en: string }[]): string {
  if (typeof text !== 'string' || text.length < 1) {
    return text;
  }
  const translated = [ ...dictionary];
  let result = text;

  translated.map((el) => {
    const reg = new RegExp(el.ua, 'g');
    result = result.replace(reg, el.en);
  });

  return result;
}